import { Link } from "react-router-dom";

const LAYERS = [
  { k: "L1", t: "Foundational Infrastructure", d: "Core UNNATI + iGOT closed-loop execution engine. Programmes, data, outcomes.",
    c: "#0077B6", items: ["Programme registry", "Outcome capture", "Competency schema"] },
  { k: "L2", t: "Open APIs & Registries", d: "Desiloed access to nationwide faculty, content, and competency data.",
    c: "#4C956C", items: ["Faculty API", "Knowledge API", "Competency registry"] },
  { k: "L3", t: "Collaborative Sandbox", d: "States, private innovators and institutes build custom services on the UNNATI foundation.",
    c: "#D95D39", items: ["State-level services", "Private innovators", "Research partners"] },
];

export default function MaturityTimeline() {
  return (
    <section id="maturity" data-testid="maturity-timeline-section" className="bg-navy text-cream py-28 md:py-36 dark-section relative overflow-hidden">
      <div className="absolute inset-0 bg-lattice-dark opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="font-mono-data text-xs tracking-[0.3em] uppercase text-[#E8B298] mb-4">04 · Path to Ecosystem Maturity</div>
            <h2 className="font-serif-display text-4xl lg:text-5xl leading-[1.05]">
              A DPI that evolves <br/><span className="italic text-[#E8B298]">from backbone to sandbox.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-sm text-cream/70">
            Each layer unlocks the next. Infrastructure becomes registries. Registries become services. Services become a national collaborative sandbox.
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {LAYERS.map((l, i) => (
            <div key={l.k} data-testid={`maturity-layer-${i}`}
                 className="relative bg-[#13233F] border border-white/10 p-8 min-h-[320px] group hover:border-[#E8B298]/50 transition-colors">
              <div className="flex items-center justify-between">
                <span className="font-mono-data text-xs tracking-[0.25em]" style={{color: l.c}}>{l.k}</span>
                <span className="font-mono-data text-xs text-cream/40">PHASE 0{i+1}</span>
              </div>
              <div className="mt-12">
                <div className="h-1 w-16 mb-6" style={{background: l.c}} />
                <h3 className="font-serif-display text-2xl leading-tight">{l.t}</h3>
                <p className="mt-3 text-sm text-cream/70 leading-relaxed">{l.d}</p>
              </div>
              <ul className="mt-6 space-y-2">
                {l.items.map(it => (
                  <li key={it} className="flex items-center gap-3 text-sm text-cream/85">
                    <span className="w-1.5 h-1.5 rounded-full" style={{background: l.c}}/>{it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-wrap items-center gap-6 border-t border-white/10 pt-10">
          <h3 className="font-serif-display text-2xl lg:text-3xl max-w-xl">
            Ready to explore the interactive modules?
          </h3>
          <Link to="/platform" data-testid="maturity-cta-platform"
                className="inline-flex items-center gap-3 bg-terracotta text-white px-6 py-3.5 font-medium hover:bg-[#c44e2e]">
            Launch UNNATI Platform <span>→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
